import { PRODUCTS_PAGE } from 'src/constants';
import { BreadCrumbBase } from 'src/legacy/components/UI/BreadCrumbBase';

export const ProductEditPageBreadcrumbs = () => {
  return (
    <BreadCrumbBase
      items={[
        {
          label: 'Products',
          path: PRODUCTS_PAGE.path,
        },
        {
          label: 'Create product',
        },
      ]}
    />
  );
};
